// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except from "../Control.Monad.Except/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var newEvent = /* #__PURE__ */ Specular_FRP_Base.newEvent(Effect_Class.monadEffectEffect);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var insert = /* #__PURE__ */ Data_Map_Internal.insert(Data_Ord.ordString);
var map = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(Data_Ord.ordString);
var $$delete = /* #__PURE__ */ Data_Map_Internal["delete"](Data_Ord.ordString);
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var show1 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_List_Types.showNonEmptyList(Foreign.showForeignError));
var Storage = function (x) {
    return x;
};
var Key = function (x) {
    return x;
};
var showKey = {
    show: function (v) {
        return show(v);
    }
};
var setItem = function (dictEncode) {
    var encodeJSON = Foreign_Generic.encodeJSON(dictEncode);
    return function (v) {
        return function (v1) {
            return function (value) {
                return v.setRawItem(v1)(encodeJSON(value));
            };
        };
    };
};
var removeItem = function (v) {
    return function (v1) {
        return v.removeRawItem(v1);
    };
};
var setItem$prime = function (dictEncode) {
    var setItem1 = setItem(dictEncode);
    return function (s) {
        return function (k) {
            return function (v) {
                if (v instanceof Data_Maybe.Nothing) {
                    return removeItem(s)(k);
                };
                if (v instanceof Data_Maybe.Just) {
                    return setItem1(s)(k)(v.value0);
                };
                throw new Error("Failed pattern match at Restaumatic.Storage (line 52, column 3 - line 54, column 28): " + [ v.constructor.name ]);
            };
        };
    };
};
var nuke = function (v) {
    return v.nuke;
};
var newtypeStorage = {
    Coercible0: function () {
        return undefined;
    }
};
var newInMemoryStorage$prime = function __do() {
    var ref = Effect_Ref["new"](Data_Map_Internal.empty)();
    var onModification = newEvent();
    return {
        storage: {
            setRawItem: function (key) {
                return function (value) {
                    return function __do() {
                        Effect_Ref.modify_(insert(key)(value))(ref)();
                        return onModification.fire(Data_Unit.unit)();
                    };
                };
            },
            getRawItem: function (key) {
                return map(lookup(key))(Effect_Ref.read(ref));
            },
            removeRawItem: function (key) {
                return function __do() {
                    Effect_Ref.modify_($$delete(key))(ref)();
                    return onModification.fire(Data_Unit.unit)();
                };
            },
            onModification: onModification.event,
            nuke: Effect_Ref.modify_(Data_Function["const"](Data_Map_Internal.empty))(ref)
        },
        ref: ref
    };
};
var newInMemoryStorage = /* #__PURE__ */ map(function (v) {
    return v.storage;
})(newInMemoryStorage$prime);
var localStorage = function __do() {
    var onModification = newEvent();
    return {
        setRawItem: function (key) {
            return function (value) {
                return function __do() {
                    $foreign["_setRawItem"](key, value);
                    return onModification.fire(Data_Unit.unit)();
                };
            };
        },
        getRawItem: function (key) {
            return function () {
                return $foreign["_getRawItem"](key, Data_Maybe.Just.create, Data_Maybe.Nothing.value);
            };
        },
        removeRawItem: function (key) {
            return function __do() {
                $foreign["_removeRawItem"](key);
                return onModification.fire(Data_Unit.unit)();
            };
        },
        onModification: onModification.event,
        nuke: $foreign["_nuke"]
    };
};
var doGetItem = function (dictDecode) {
    var decodeJSON = Foreign_Generic.decodeJSON(dictDecode);
    return function (v) {
        return function (v1) {
            return function __do() {
                var m_rawValue = v.getRawItem(v1)();
                if (m_rawValue instanceof Data_Maybe.Nothing) {
                    return new Data_Either.Left("Unable to find Storage key " + show(v1));
                };
                if (m_rawValue instanceof Data_Maybe.Just) {
                    return lmap(function (err) {
                        return "Unable to decode Storage key " + (show(v1) + (": " + show1(err)));
                    })(Control_Monad_Except.runExcept(decodeJSON(m_rawValue.value0)));
                };
                throw new Error("Failed pattern match at Restaumatic.Storage (line 71, column 10 - line 73, column 140): " + [ m_rawValue.constructor.name ]);
            };
        };
    };
};
var getItem = function (dictDecode) {
    var doGetItem1 = doGetItem(dictDecode);
    return function (storage) {
        return function (key) {
            return function __do() {
                var itemOrError = doGetItem1(storage)(key)();
                if (itemOrError instanceof Data_Either.Left) {
                    return Data_Maybe.Nothing.value;
                };
                if (itemOrError instanceof Data_Either.Right) {
                    return new Data_Maybe.Just(itemOrError.value0);
                };
                throw new Error("Failed pattern match at Restaumatic.Storage (line 64, column 3 - line 66, column 29): " + [ itemOrError.constructor.name ]);
            };
        };
    };
};
var newPersistentRef = function (dictMonadFRP) {
    var Monad0 = (dictMonadFRP.MonadCleanup1()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind1 = Control_Bind.bind(Bind1);
    var MonadEffect0 = dictMonadFRP.MonadEffect0();
    var liftEffect = Effect_Class.liftEffect(MonadEffect0);
    var newRef = Specular_Ref.newRef(MonadEffect0);
    var discard2 = discard(Bind1);
    var subscribeDyn_ = Specular_FRP_Base.subscribeDyn_(dictMonadFRP);
    var pure1 = Control_Applicative.pure(Monad0.Applicative0());
    return function (dictEncode) {
        var setItem1 = setItem(dictEncode);
        return function (dictDecode) {
            var getItem1 = getItem(dictDecode);
            return function (storage) {
                return function (key) {
                    return function (defaultValue) {
                        return bind1(liftEffect(map(Data_Maybe.fromMaybe(defaultValue))(getItem1(storage)(key))))(function (initialValue) {
                            return bind1(newRef(initialValue))(function (ref) {
                                return discard2(subscribeDyn_(setItem1(storage)(key))(Specular_Ref.refValue(ref)))(function () {
                                    return pure1(ref);
                                });
                            });
                        });
                    };
                };
            };
        };
    };
};
var persistentFoldDyn = function (dictMonadFRP) {
    var Monad0 = (dictMonadFRP.MonadCleanup1()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind1 = Control_Bind.bind(Bind1);
    var liftEffect = Effect_Class.liftEffect(dictMonadFRP.MonadEffect0());
    var foldDyn = Specular_FRP_Base.foldDyn(dictMonadFRP);
    var discard2 = discard(Bind1);
    var subscribeDyn_ = Specular_FRP_Base.subscribeDyn_(dictMonadFRP);
    var pure1 = Control_Applicative.pure(Monad0.Applicative0());
    return function (dictEncode) {
        var setItem1 = setItem(dictEncode);
        return function (dictDecode) {
            var getItem1 = getItem(dictDecode);
            return function (storage) {
                return function (key) {
                    return function (f) {
                        return function (defaultValue) {
                            return function (event) {
                                return bind1(liftEffect(map(Data_Maybe.fromMaybe(defaultValue))(getItem1(storage)(key))))(function (initialValue) {
                                    return bind1(foldDyn(f)(initialValue)(event))(function (dyn) {
                                        return discard2(subscribeDyn_(setItem1(storage)(key))(dyn))(function () {
                                            return pure1(dyn);
                                        });
                                    });
                                });
                            };
                        };
                    };
                };
            };
        };
    };
};
var getItemIfExists = function (dictDecode) {
    var doGetItem1 = doGetItem(dictDecode);
    return function (storage) {
        return function (key) {
            return map(Data_Either.hush)(doGetItem1(storage)(key));
        };
    };
};
var blackHoleStorage = {
    setRawItem: function (v) {
        return function (v1) {
            return pure(Data_Unit.unit);
        };
    },
    getRawItem: function (v) {
        return pure(Data_Maybe.Nothing.value);
    },
    removeRawItem: function (v) {
        return pure(Data_Unit.unit);
    },
    onModification: Specular_FRP_Base.never,
    nuke: /* #__PURE__ */ pure(Data_Unit.unit)
};
export {
    Key,
    Storage,
    blackHoleStorage,
    getItemIfExists,
    localStorage,
    newInMemoryStorage,
    newInMemoryStorage$prime,
    newPersistentRef,
    nuke,
    persistentFoldDyn,
    removeItem,
    getItem,
    setItem,
    setItem$prime,
    newtypeStorage,
    showKey
};
